import { useEffect, useRef, useState } from "react";
import "./Range.css";

const Range = ({ min: propMin = 0, max: propMax = 1200, label, step = 1, onChange, minLimit = 0, maxLimit = 1200 }) => {
  const rangeRef = useRef(null);
  const [minVal, setMinVal] = useState(propMin);
  const [maxVal, setMaxVal] = useState(propMax);

  // Sync when parent props change
  useEffect(() => {
    setMinVal(propMin);
  }, [propMin]);

  useEffect(() => {
    setMaxVal(propMax);
  }, [propMax]);

  // Ensure limits make sense
  const lowerLimit = typeof minLimit === "number" ? minLimit : 0;
  const upperLimit = typeof maxLimit === "number" ? maxLimit : 1200;

  const clamp = (v, a, b) => Math.min(Math.max(v, a), b);

  const handleMinChange = (e) => {
    const val = clamp(Number(e.target.value), lowerLimit, maxVal - step);
    setMinVal(val);
    if (onChange) onChange(val, maxVal);
  };

  const handleMaxChange = (e) => {
    const val = clamp(Number(e.target.value), minVal + step, upperLimit);
    setMaxVal(val);
    if (onChange) onChange(minVal, val);
  };

  const handleMinInput = (e) => {
    const val = clamp(Number(e.target.value), lowerLimit, maxVal - step);
    setMinVal(val);
    if (onChange) onChange(val, maxVal);
  };

  const handleMaxInput = (e) => {
    const val = clamp(Number(e.target.value), minVal + step, upperLimit);
    setMaxVal(val);
    if (onChange) onChange(minVal, val);
  };

  // update track fill
  const percentLeft = ((minVal - lowerLimit) / (upperLimit - lowerLimit)) * 100;
  const percentRight = ((maxVal - lowerLimit) / (upperLimit - lowerLimit)) * 100;

  return (
    <div className="range-wrapper mb-4">
      <label className="form-label fw-bold">{label}</label>
      <div className="slider-container">
        <div className="slider-track-bg" />
        <div
          className="slider-track"
          ref={rangeRef}
          style={{ left: `${percentLeft}%`, width: `${percentRight - percentLeft}%` }}
        />
        <input
          type="range"
          min={lowerLimit}
          max={upperLimit}
          step={step}
          value={minVal}
          onChange={handleMinChange}
          className="thumb thumb-left"
        />
        <input
          type="range"
          min={lowerLimit}
          max={upperLimit}
          step={step}
          value={maxVal}
          onChange={handleMaxChange}
          className="thumb thumb-right"
        />
      </div>
      <div className="range-values mt-2 d-flex gap-2">
        <input
          type="number"
          className="form-control"
          value={minVal}
          onChange={handleMinInput}
        />
        <span className="mt-1">to</span>
        <input
          type="number"
          className="form-control"
          value={maxVal}
          onChange={handleMaxInput}
        />
      </div>
    </div>
  );
};

export default Range;
